import awardMain from '@/views/award/awardMain.vue'

export default [
  {
    path: '/awardMain',
    name: 'AwardMain',
    component: awardMain,
    meta: {
      title: '冲单激励',
      keepAlive: true, // init 缓存
      isApp: true
    }
  }
]
